import React, { useEffect, useState } from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'
import TestimonialForm from '../component/TestimonialForm/TestimonialForm'
import KeyFeatureText from '../component/KeyFeatureText/KeyFeatureText'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import TextContent from '../component/TextContent/TextContent'
import VideoContent from '../component/VideoContent/VideoContent'
import TeamCards from '../component/TeamCards/TeamCards'

const text1List = [
  "Customized treatment plans tailored to your specific needs.",
  "Utilization of evidence-based techniques and modalities.",
  "Manual therapies, therapeutic exercises, and various pain management modalities.",
  "Recovery from injury, management of chronic pain, and improvement of mobility.",
  "Support for post-surgery rehabilitation and sports injury recovery.",
  "Treatment for pelvic floor physio therapy.  ",
]


const text2List = [
  "Hands-on adjustments and manipulations to restore proper alignment.",
  "Alleviation of back and neck pain, headaches, jaw pain, and various other musculoskeletal issues.",
  "Optimization of the spine and nervous system health.",
  "Enhancement of the body's natural healing processes.",
  "Personalized care to address individual health goals.",
  
]
const text3List = [
  "Various massage techniques including Swedish, deep tissue, and sports massage.",
  "Reduction of muscle tension, stress, and pain.",
  "Promotion of circulation and overall well-being.",
  "Recovery aid for injury rehabilitation.",
  "Relaxation and relief from everyday aches and pains.",
  
]
const text4List = [
  "Reduction of leg discomfort, swelling, and edema.",
  "Improvement of circulation and alleviation of symptoms associated with vascular conditions.",
  "Varied styles and compression levels to suit individual needs.",
  "Relief for tired, achy legs and prevention of complications.",
  "Support for recovery from surgery and management of chronic conditions.",
  
]

const text5List = [
  "Non-invasive treatment for musculoskeletal conditions such as plantar fasciitis, heel spurs, and tendonitis.",
  "Stimulation of natural healing processes and tissue regeneration.",
  "Reduction of inflammation and pain.",
  "Customized treatment plans based on individual assessment.",
  "Effective relief for sports injuries, repetitive strains, and degenerative conditions such as arthritis.",
  
]

const text6List = [
  "Assessment of foot structure and gait patterns.",
  "Creation of custom made orthotic inserts for optimal support and alignment.",
  "Selection of high-quality footwear compatible with orthotics.",
  "Improvement of posture and alleviation of foot-related pain.",
  "Enhanced comfort and mobility for daily activities.",
  
]

const text7List = [
  "Custom measurements for knee, ankle, and back braces, etc.  ",
  "Address complaints such as patellar tendinitis (jumper’s knee), lateral epicondylitis (tennis elbow), etc. with a custom measured brace to reduce the pain during activity.  ",

]

// Accunpture
const text8List = [
  "Targeted needle placement customized to your unique health profile for maximum effectiveness.",
  "Address chronic pain, stress, digestive issues, and more through a comprehensive body-mind approach.",
  "Stimulate your body’s meridians to improve circulation and boost natural healing processes.",
  "Combining cutting-edge practices with time-tested acupuncture methods for superior results.",
  // "Ongoing support and adjustments tailored to your lifestyle and health goals.",

]

// Psychology
const text9List = [
"Connect with your therapist on your terms—anytime, anywhere, without commuting stress.",
"Sessions conducted via encrypted platforms to ensure your privacy and peace of mind.",
"Tailored treatments including CBT, mindfulness, and trauma-informed care to fit your unique needs.",
"Expert guidance through anxiety, depression, relationship struggles, and major life transitions.",
// "Practical strategies and ongoing resources designed to empower you beyond the session."
]

// Pelvic Floor
const text10List = [
  "Personalized exercises and manual therapy to restore strength and flexibility in your pelvic floor muscles.",
"Detailed evaluation of pelvic alignment, muscle function, and related areas for precise treatment planning.",
"Tailored care for pregnancy, postpartum recovery, menopause, and pelvic surgery rehabilitation.",
"Evidence-based strategies to reduce urinary leakage, pelvic pain, and discomfort with lasting results.",
// "Practical guidance on posture, breathing, and lifestyle adjustments to maintain pelvic health long-term."
]

// Concussion
const text11List = [
  "Customized protocols based on your symptoms, injury history, and lifestyle for optimal healing.",
"Integrating physical therapy, vestibular rehab, cognitive training, and education to address all aspects of recovery.",
"Targeted strategies to reduce headaches, dizziness, fatigue, and cognitive fog.",
// "Safe, step-by-step guidance to help you resume work, sports, and daily life without setbacks.",
// "Regular assessments and adjustments to ensure continuous progress and prevent complications."
]

// homecare
const text12List = [
  "From warm caregivers to licensed physiotherapists, chiropractors, psychologists, and naturopaths, everyone is here to support your unique journey.",
"We pay attention to the little changes that matter, so problems don’t sneak up on you.",
"We treat your home, your time, and your privacy with the care they deserve.",
"Whether it’s a gentle conversation or a hands-on therapy session, our team is here to lift your spirits and your strength.",
"We keep learning new ways to support you better, because you deserve the best."
]

function Physiotherapy() {
  const {id} = useParams()
  const [headingTitle , setHeadingTitle] = useState("")
  const [bannerImg , setBannerImg] = useState("/images/creatives/phys-hero-bg.jpg")
  const [metaTitle , setMetaTitle] = useState("");
  const [metaDesc , setMetaDesc] = useState('');
  const [textContentProp,setTextContentProp] = useState(null)
  const [teamIndex,setTeamIndex] = useState([-1])
  
  const navigate = useNavigate()

  const idToInd = () => {
    let servId = 1;
    let bannerHeading= ''
    let bgImg = ""
    let metaT = ""
    let metaD = ""
    let textContentProps = null
    let teamIndex = null
    switch (id) {
      case "physiotherapy":
        servId = 1;
        bannerHeading = "Physiotherapy";
        bgImg = '/images/creatives/physiotherypy-hero.webp'
        metaT = "Restore Mobility & Wellness | True Life Physiotherapy"
        metaD = "Experience personalized physiotherapy for pain relief & recovery. Our experts offer chiropractic treatment, massage therapy, acupuncture & more. Contact us today!"
        textContentProps = {
          heading:"Physiotherapy",
          subHeading:"",
          content:"",
          postBtn:true,
          btnText:"Book Appointment",
          btnRef:'jnape',
          btnIcon:true,
          shiftRow:true,
          marginTop:true,
          // img:"/images/creatives/about-text-3.png",
          img:"/images/NewImages/Physiotherapy.png",
          reviewContent:false,
          listPoint:text1List,
          listPointList:true,
        }
        teamIndex =[1,3]
        break;
        case "chiropractic-treatment":
          servId = 2;
          bannerHeading = "Chiropractic Treatment";
          bgImg = '/images/creatives/chiropractic-treatment-hero.webp'
          metaT = "Expert Chiropractic Treatment Care for Pain Relief | True Life Wellness"
          metaD = "Experience personalized physiotherapy for pain relief & recovery. Our experts offer chiropractic treatment, massage therapy, acupuncture & more. Contact us today!"
          textContentProps={
            heading: "Chiropractic",
            subHeading: "",
            content: "",
            postBtn: true,
            btnText: "Book Appointment",
            btnRef: "jnape",
            btnIcon: true,
            shiftRow: false,
            marginTop: true,
            // img: "/images/creatives/about-text-4.png",
            // img: "/images/NewImages/Chiropractic-Treatment.png",
            img: "/images/creatives/chiropractic-treatment.png",
            reviewContent: false,
            listPoint: text2List,
            listPointList: true
          }
          
        teamIndex =[0]
          break;
          case "registered-massage-therapy":
            servId = 3;
            bannerHeading = "Registered Massage Therapy";
            bgImg = '/images/creatives/registered-massage-therapy-hero.webp'
            metaT = "Holistic Massage Therapy Services | True Life Wellness"
            metaD = "Experience relief from muscle tension, pain, and stress with our registered massage therapy. Book your session today for optimal physical and emotional well-being."
            textContentProps={
              heading: "Massage Theraphy",
              subHeading: "",
              content: "",
              postBtn: true,
              btnText: "Book Appointment",
              btnRef: "jnape",
              btnIcon: true,
              shiftRow: true,
              marginTop: true,
              // img: "/images/creatives/about-text-5.png",
              img: "/images/NewImages/Registered-Massage-Therapy.png",
              reviewContent: false,
              listPoint: text3List,
              listPointList: true
            };
            
        teamIndex =[4]
        break;
      case "acupuncture":
        servId = 4;
        bannerHeading = "Acupuncture";
        bgImg = '/images/creatives/acupuncture-hero.webp'
        metaT = "Expert Acupuncture Services | True Life Wellness & Physiotherapy"
        metaD = "Discover the healing benefits of acupuncture at True Life Wellness & Physiotherapy. Reduce pain, inflammation, and stress with our licensed acupuncturist."
        textContentProps={
             heading: "Experience relief with acupuncture",
             subHeading: "",
             content: "Experience acupuncture that goes beyond traditional healing — tailored to unlock your body’s natural vitality and promote deep, lasting wellness.",
             postBtn: true,
             btnText: "Book Appointment",
             btnRef: "jnape",
             btnIcon: true,
             shiftRow: true,
             marginTop: true,
             // img: "/images/creatives/about-text-5.png",
             img: "/images/NewImages/Acupuncture.png",
             reviewContent: false,
             listPoint: text8List,
             listPointList: true
           };
        teamIndex =[5]
        break;
      case "psychology":
        servId = 5;
        bannerHeading = "Psychological Counseling";
        bgImg = '/images/creatives/psychology-hero.webp'
        metaT = "Virtual Psychological Counseling Services | True Life Wellness"
        metaD = "Seek confidential mental health support from licensed psychologists at True Life Wellness. Manage stress, anxiety, and depression through secure virtual sessions. "
        textContentProps={
           heading: "Mental Clarity Wherever You Are",
           subHeading: "",
           content: "Access compassionate, evidence-based psychological support from the comfort and privacy of your own space—because your mental well-being shouldn’t have boundaries.",
           postBtn: true,
           btnText: "Book Appointment",
           btnRef: "jnape",
           btnIcon: true,
           shiftRow: true,
           marginTop: true,
           // img: "/images/creatives/about-text-5.png",
           img: "/images/NewImages/Psychology.png",
           reviewContent: false,
           listPoint: text9List,
           listPointList: true
         };
        teamIndex =[6]
        break;
      case "naturopathic-medicine":
        servId = 6;
        bannerHeading = "Naturopathic Medicine";
        bgImg = '/images/creatives/naturopathic-medicine-hero.webp'
        metaT = "Holistic Naturopathic Medicine | True Life Wellness"
        metaD = "Experience holistic health with our naturopathic medicine services. Our licensed doctors offer personalized care to optimize nutrition, balance hormones, and enhance vitality. Book now!"
        
        teamIndex =[-1]
        break;
      case "custom-made-orthotics-and-shoes":
        servId = 7;
        bannerHeading = "Custom Made Orthotics and Shoes";
        bgImg = '/images/creatives/custom-made-orthotics-and-shoes-hero.webp'
        metaT = "Custom Orthotics & Shoes for Pain Relief | True Life Wellness"
        metaD = "Find relief from foot pain with custom-made orthotics and shoes at True Life Wellness. Correct deformities, improve balance, and prevent injuries. Book your appointment today!"
        textContentProps={
          heading: "Custom Made Orthotics and Shoes",
          subHeading: "",
          content: "",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: false,
          marginTop: true,
          img: "/images/creatives/about-text-6.1.webp",
          reviewContent: false,
          listPoint: text6List,
          listPointList: true
        }
        
        teamIndex =[-1]
        break;
      case "custom-made-braces":
        servId = 8;
        bannerHeading = "Custom Made Braces";
        bgImg = '/images/creatives/custom-made-braces-hero.webp'
        metaT = "Custom Made Braces for Optimal Support | True Life Wellness"
        metaD = "Regain mobility and prevent further injury with custom-made braces from True Life Wellness. Perfect fit, targeted support, and improved function. Book now!"
        textContentProps={
          heading: "Custom Measured Braces",
          subHeading: "",
          content: "",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: true,
          marginTop: true,
          img: "/images/creatives/about-text-9.webp",
          reviewContent: false,
          listPoint: text7List,
          listPointList: true
        }
        
        teamIndex =[-1]
        break;
      case "pelvic-floor-physiotherapy":
        servId = 9;
        bannerHeading = "Pelvic Floor Physiotherapy";
        bgImg = '/images/creatives/pelvic-floor-physiotherapy-hero.jpg'
        metaT = "Expert Pelvic Floor Physiotherapy | True Life Wellness & Physiotherapy"
        metaD = "Alleviate pelvic pain and enhance bladder function with specialized pelvic floor physiotherapy at True Life Wellness & Physiotherapy. Book your appointment now!"
        textContentProps={
          heading: "Strengthen, Restore, and Reclaim Confidence",
          subHeading: "",
          content: "Specialized pelvic floor physiotherapy designed to empower your core health, improve function, and enhance your quality of life—whether recovering, managing, or preventing pelvic concerns.",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: true,
          marginTop: true,
          img: "/images/NewImages/Pelvic-Floor-Physiotherapy.png",
          reviewContent: false,
          listPoint: text10List,
          listPointList: true
        }
        teamIndex =[8]
        break;
      case "concussion-rehabilitation":
        servId = 10;
        bannerHeading = "Concussion Rehabilitation";
        bgImg = '/images/creatives/concussion-rehabilitation-hero.webp'
        metaT = "Alleviate pelvic pain and enhance bladder function with specialized pelvic floor physiotherapy at True Life Wellness & Physiotherapy. Book your appointment now!"
        metaD = "Recover fully from traumatic brain injuries with our specialized concussion rehabilitation programs. Regain balance, cognitive function, and independence. "
        textContentProps={
          heading: "Recover Smarter, Return Stronger",
          subHeading: "",
          content: "Comprehensive concussion rehabilitation designed to support your brain’s healing process, helping you regain function and confidence safely and effectively.",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: true,
          marginTop: true,
          img: "/images/NewImages/Chiropractic-Treatment.png",
          reviewContent: false,
          listPoint: text11List,
          listPointList: true
        }
        teamIndex =[-1]
        break;
      case "shockwave-therapy":
        servId = 11;
        bannerHeading = "Shockwave Therapy";
        bgImg = '/images/creatives/shockwave-therapy-hero.webp'
        metaT = "Effective Shockwave Therapy | True Life Wellness & Physiotherapy"
        metaD = "Find relief from chronic pain and musculoskeletal conditions with our non-invasive shockwave therapy. Reduce inflammation, promote tissue regeneration, and accelerate recovery. Book now!"
        textContentProps={
          heading: "Shockwave Theraphy",
          subHeading: "",
          content: "Effective Treatment For:",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: true,
          marginTop: true,
          img: "/images/creatives/about-text-8.png",
          reviewContent: false,
          adjecentlistPoint: text5List,
          adjecentlistPointList: true
        }
        
        teamIndex =[-1]
        break;
      case "cold-laser-therapy":
        servId = 12;
        bannerHeading = "Cold Laser Therapy";
        bgImg = '/images/creatives/cold-laser-therapy-hero.webp'
        metaT = "Advanced Cold Laser Therapy for Pain Relief | True Life Wellness "
        metaD = "Experience effective pain relief and accelerated healing with cold laser therapy at True Life Wellness and Physiotherapy."
        
        teamIndex =[-1]
        break;
      case "compression-apparel":
        servId = 13;
        bannerHeading = "Compression Apparel";
        bgImg = '/images/creatives/compression-apparel-hero.webp'
        metaT = "Revitalize Your Health with Compression Apparel"
        metaD = "Discover the transformative benefits of compression apparel. Enhance circulation, reduce swelling, and boost muscle recovery. Book now!"
        textContentProps={
          heading: "Compression Stockings",
          subHeading: "",
          content: "",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: false,
          marginTop: true,
          // img: "/images/creatives/about-text-7.png",
          img: "/images/NewImages/Compression-Apparel.png",
          reviewContent: false,
          listPoint: text4List,
          listPointList: true
        }
        
        teamIndex =[2]
        break;
      case "home-care":
        servId = 14;
        bannerHeading = "Home Care";
        bgImg = '/images/creatives/home-care-hero.jpg'
        metaT = ""
        metaD = ""
        textContentProps={
          heading: "Caregivers and Therapists Who Truly See You",
          subHeading: "",
          content: "Our team isn’t just skilled—they’re compassionate people who get that you’re more than your health challenges. We become a steady, supportive presence you can count on.",
          postBtn: true,
          btnText: "Book Appointment",
          btnRef: "jnape",
          btnIcon: true,
          shiftRow: false,
          marginTop: true,
          // img: "/images/creatives/home-text-1.webp",
          img: "/images/creatives/Home-Banner-team.png",
          reviewContent: false,
          listPoint: text12List,
          listPointList: true
        }
        
        teamIndex =[-1]
        break;

      default:
        navigate("/services")
        break;
    }

    return {servId:servId , bannerHeading:bannerHeading , bgImg : bgImg , metaT: metaT , metaD : metaD,textContentProps:textContentProps,teamIndex:teamIndex};
  };

  
  
  const [ind,setInd] = useState(idToInd().servId)
  useEffect(()=>{
    setHeadingTitle(()=>idToInd().bannerHeading)
    setInd(()=>idToInd().servId);
    setBannerImg(()=>idToInd().bgImg);
    setMetaTitle(()=>idToInd().metaT)
    setMetaDesc(()=>idToInd().metaD)
    setTextContentProp(()=>idToInd().textContentProps)
    setTeamIndex(()=>idToInd().teamIndex)
  } , [id])
  
    return (
        <div className="home-page">
          <Helmet>
            <title>
            {metaTitle}
            </title>
            <meta
              name="description"
              content={metaDesc}
            ></meta>
          </Helmet>
          <HeroBanner 
            subHeading=""
            Heading={headingTitle}
            spanHeading=''
            Paragraph=""
            nextLineSpanHeading=""
            bgImg={bannerImg}
            btn={false}
            isCheveron={false}
            btnRef="/"
            txtStart={false}
            btnTel={true}
          />
          
          {
            textContentProp &&
            <TextContent
              {...textContentProp}
              btnTel={true}
            />
          }
          {
            ind == 7 ?
          <div className='container d-flex flex-column py-5'>
            {/* <h3 className='body-heading text-center mb-5'>What is Plantar Fasciitis</h3> */}
            <video className="iframe-vid mx-auto" style={{borderRadius:"20px",maxWidth:"80%"}} controls playsInline muted autoPlay={true} controlsList='nodownload'
            >
                <source src={"/images/video-content-1.mp4"} type="video/mp4" />
                
                Your browser does not support the video tag.
            </video>
           
          </div>
            : ind == 9?
              <>
              <div className='container d-flex flex-column py-5'>
            {/* <h3 className='body-heading text-center mb-5'></h3> */}
          
            <iframe className='iframe-vid mx-auto' loading="lazy"  style={{borderRadius:"20px",maxWidth:"80%",width:"85vw",height:"450px"}}
            src="https://www.youtube.com/embed/2WsP_j60C6A?si=sFJUkEaoKI4tolt4" 
            title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>
              
             
                 <div className='testimonial-container container pb-5'>
                <h3 className='body-heading text-center pb-4'>Video Testimonials</h3>
               <div className='row gy-lg-0 gy-4'>
                <div className='col-lg-6 d-flex align-items-center'>
                  <video className="iframe-vid mx-auto" style={{borderRadius:"20px",maxWidth:"80%",maxHeight:"400px"}} controls playsInline muted autoPlay={false} controlsList='nodownload'
                        >
                            <source src={"/images/pelvic-floor-video.mp4"} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                  
                </div>
                <div className='col-lg-6 d-flex'>
                <video className="iframe-vid mx-auto" style={{borderRadius:"20px",maxWidth:"80%",maxHeight:"400px"}} controls playsInline muted autoPlay={false} controlsList='nodownload'
                        >
                            <source src={"/images/pelvic-floor-video-1.mp4"} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                  
                </div>
               </div>
              </div>
               </>
            :
          <div className='container d-flex flex-column py-5'>
            <h3 className='body-heading text-center mb-5'>Take a Tour of Our Clinic</h3>
            {/* <video className="iframe-vid mx-auto" style={{borderRadius:"20px",maxWidth:"80%"}} controls playsInline muted autoPlay={true} controlsList='nodownload'
            >
                <source src={"/images/clinic-tour-video.mp4"} type="video/mp4" />
                
                Your browser does not support the video tag.
            </video> */}
            <iframe className='iframe-vid mx-auto' loading="lazy"  style={{borderRadius:"20px",maxWidth:"80%",width:"85vw",height:"450px"}}
            src="https://www.youtube.com/embed/TXDyv_ILrTg?si=6DWbhkPCU7EQz1r3" 
            title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          }
    <div className='right-gradient'>
      <div className='left-gradient'>
          <KeyFeatureText
            ind={ind}
          />
          
    </div>
    {
      ind ==  4 &&
      <div className='container d-flex flex-column py-5'>
        <div className='row '>
          <div className='col-lg-4 d-flex'>
             <video className="iframe-vid mx-auto" loading="lazy" style={{borderRadius:"20px",maxWidth:"80%"}} controls playsInline muted autoPlay={true} controlsList='nodownload'
        >
            <source src={"/images/acunpture-page-video.mp4"} type="video/mp4"  />
            Your browser does not support the video tag.
        </video>
          </div>
          <div className='col-lg-4 d-flex'>
             <video className="iframe-vid mx-auto" loading="lazy" style={{borderRadius:"20px",maxWidth:"80%"}} controls playsInline muted autoPlay={true} controlsList='nodownload'
        >
            <source src={"/images/acunpture-page-video-2.mp4"} type="video/mp4"  />
            Your browser does not support the video tag.
        </video>
          </div>
          <div className='col-lg-4 d-flex'>
             <video className="iframe-vid mx-auto" loading="lazy" style={{borderRadius:"20px",maxWidth:"80%"}} controls playsInline muted autoPlay={true} controlsList='nodownload'
        >
            <source src={"/images/acunpture-page-video-3.mp4"} type="video/mp4"  />
            Your browser does not support the video tag.
        </video>
          </div>

      </div>
      </div>
    }

      {
        ind == 9 &&
          <>
            <TextContent
              heading="Prolapse is very common effecting 1 in 3 women who have had children"
              subHeading= ""
              content={"Pelvic floor muscles act as a hammock to support pelvic organs, If either Pelvic floor muscles or the supporting structures are weakened, pelvic organs bulge into the vagina causing vaginal walls to move downwards resulting in prolapse. Obesity, Age and Menopausal changes can also cause prolapse. Freedom+TM autonomic (involuntary) muscular contracts strengthen pelvic floor muscles in subsequently increase vaginal support and prolapse reversal."}
              btn={false}
              btnText="Book An Appointment"
              btnRef='jnape'
              btnIcon={true}
              shiftRow={true}
              marginTop={false}
              img="/images/creatives/pelvic-text-1.png"
              reviewContent={false}
              postBtn={true}
            />
            <TextContent
              heading="How it works"
              subHeading= ""
              content={""}
              customContent={"<strong>Stress Urinary Incontinence (SUI)</strong> Freedom+TM stimulation targets the pelvic and/or pudendal nerves, and the external sphincters. Consequently, restoring PFM muscle integrity.<br/> <strong>In Urge Urinary Incontinence, (UUI)</strong> Freedom+TM targets the afferent branches of the pudendal nerve are stimulated to inhibit the detrusor muscle through central reflexes; at the same time, the efferent nerve branches are also stimulated to facilitate strengthening of the pelvic floor muscles and increase the tonus of the urethral sphincters."}
              btn={false}
              btnText="Book An Appointment"
              btnRef='jnape'
             postBtn={true}
              btnIcon={true}
              shiftRow={false}
              marginTop={false}
              img="/images/creatives/pelvic-text-2.png"
              reviewContent={false}
            />

              {/* <div className='half-gradient-container my-5'>
                <VideoContent
                  img1={"/images/creatives/video-card-pelvic-img.png"}
                  // videoSrc2={"https://www.youtube.com/embed/okEd3GQq4QY?si=7lFjPg9EmGLfCxFr"}
                  videoSrc1={"https://www.youtube.com/embed/2WsP_j60C6A?si=sFJUkEaoKI4tolt4"}
                  singleVideo={true}
                  bottomContent="In Urge Urinary Incontinence, (UUI) Freedom+TM targets the afferent branches of the pudendal nerve are stimulated to inhibit the detrusor muscle through central reflexes; at the same time, the efferent nerve branches are also stimulated to facilitate strengthening of the pelvic floor muscles and increase the tonus of the urethral sphincters."
                  openVideo={true}
                  directVideo={false}
                  youtubeVideo={true}
                />
              </div> */}
             
          </>
      }
    
    </div>
    
    {/* <TeamCards
     indAr={teamIndex}
    /> */}
          <TestimonialForm marginBottom={false}/>
    
    
          <Footer/>
          </div>
      )
}

export default Physiotherapy